var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$wait.is("fetching preview resource")
      ? _c(
          "div",
          { staticClass: "loading" },
          [_c("Spinner", { attrs: { height: 40, width: 40 } })],
          1
        )
      : _vm.resource && _vm.resource.items.length > 0
      ? _c(
          "ul",
          { staticClass: "league-table" },
          _vm._l(_vm.resource.items, function (item, index) {
            return _c("li", { staticClass: "league-table__item" }, [
              _c(
                "div",
                {
                  class: [
                    "league-position",
                    `league-position--${item.direction}`,
                  ],
                },
                [
                  _c("div", {
                    staticClass: "league-position__rank",
                    domProps: { textContent: _vm._s(index + 1) },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "league-position__person" },
                    [
                      item.user
                        ? _c("UserCard", {
                            attrs: {
                              user: item.user,
                              borderless: true,
                              tiny: true,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ])
          }),
          0
        )
      : _c("h3", [_vm._v("No Data")]),
    _vm._v(" "),
    _vm.resource && _vm.resource.last_updated
      ? _c("span", { staticClass: "last-updated" }, [
          _vm._v("Last updated: " + _vm._s(_vm.resource.last_updated)),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }